export default "__VITE_ASSET__f772de7e__"